import { render, staticRenderFns } from "./FormulateProposal.vue?vue&type=template&id=1efed741&"
import script from "./FormulateProposal.vue?vue&type=script&lang=js&"
export * from "./FormulateProposal.vue?vue&type=script&lang=js&"
import style0 from "./FormulateProposal.vue?vue&type=style&index=0&id=1efed741&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports